import {
  PaymentLineItemType,
  PaymentMethod,
  Payments,
  PaymentType,
} from '@prisma/client';
import type { getLineItemLabel } from '../helpers/payments';

export const PAYMENT_GROUPS_PAGE_SIZE = 10;
export const SORTABLE_KEYS: Array<keyof Payments> = ['amount', 'createdAt'];
export const MINIMUM_PAYMENT_CENTS = 50;
export const TERMINAL_MIN_FEE_CENTS = 200;
export const ONLINE_MIN_FEE_CENTS = 400;

export const ALLOWED_VOID_PAYMENT_TYPES: PaymentType[] = [
  PaymentType.FULL,
  PaymentType.DEPOSIT,
  PaymentType.RESCHEDULE,
  PaymentType.ORDER,
];

export const ALLOWED_VOID_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.CASH,
  PaymentMethod.DIGITAL,
  PaymentMethod.GIFT_CARD,
];

export const CREDIT_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.CREDIT,
  PaymentMethod.TERMINAL,
];

export const BNPL_FEE_RATE = 0.04;

export const DISCOUNT_LINE_ITEM_TYPES: PaymentLineItemType[] = [
  'RETAIL_DISCOUNT',
  'SERVICE_DISCOUNT',
];

export const EXCLUDED_SUM_LINE_ITEM_TYPES: PaymentLineItemType[] = [
  'FEE',
  'RETAIL_DISCOUNT',
  'SERVICE_DISCOUNT',
];

// Lines whose displayed amount absorbs cash discount inflation (so feeless
// payments still show the all-in price).
export const INFLATABLE_LINE_ITEM_TYPES: PaymentLineItemType[] = [
  'SERVICE',
  'SERVICE_RESCHEDULE',
  'RETAIL_ITEM',
];

export const TAX_LINE_ITEM_TYPES: PaymentLineItemType[] = [
  'SERVICE_TAX',
  'SERVICE_RESCHEDULE_TAX',
  'RETAIL_ITEM_TAX',
];

export const LINE_ITEMS_ORDER: ReturnType<typeof getLineItemLabel>[] = [
  'Appointment',
  'Retail Item',
  'Rescheduling Fee(s)',
  'Discount',
  'Sales Tax',
  'Tip',
  'Service Fee',
];

export const DEFAULT_CASH_DISCOUNT_ENABLED = false;
